import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = PropsWithChildren<{
  readonly id: string;
}>;

export function Portal({ id, children }: PortalProps) {
  let container = document.getElementById(id);

  if (!children) {
    return null;
  }

  if (!container) {
    const newContainer = document.createElement('div');
    newContainer.id = id;
    document.body.appendChild(newContainer);
    container = newContainer;
  }

  return createPortal(children, container);
}
